import withPasswordHookForm from '../hoc/withPasswordHookForm';
import InputBox from './InputBox';

const InputBoxPasswordWithHookForm = withPasswordHookForm(InputBox);

export default InputBoxPasswordWithHookForm;
